import React from 'react'
import './footer.css'

import tiktokIcon from '../../assets/icons/tiktok.svg'
import facebookIcon from '../../assets/icons/facebook.svg'
import instaIcon from '../../assets/icons/instagram.svg'

const Footer = () => {
  return <div className='footer'>
    <div className="w footerIcons">
      <a rel="noreferrer" target='_blank' href="https://www.tiktok.com/@ravisara.jayamanna">
      <span className='socialMedia-links'>
        <img className='socialMedia__icons' src={tiktokIcon} alt="" />
        tiktok
      </span>
      </a>
      <span className="dot"></span>
      <a rel="noreferrer" target='_blank' href="https://web.facebook.com/ravisarajayamannawildlifephotography">
      <span className='socialMedia-links'>
        <img className='socialMedia__icons' src={facebookIcon} alt="" />
        facebook
      </span>
      </a>
      <span className="dot"></span>
      <a rel="noreferrer" target='_blank' href="https://www.instagram.com/ravisara.jayamanna/">
      <span className='socialMedia-links'>
        <img className='socialMedia__icons' src={instaIcon} alt="" />
        instagram
      </span>
      </a>
    </div>
  </div>
}

export default Footer